import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";
import type { GetVisitsQuery, GetVisitsResponse } from "./type";

async function getVisits(query: GetVisitsQuery): Promise<GetVisitsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.visits.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetVisitsResponse>(url);

  return response.data;
}

export function useGetVisits(
  query: GetVisitsQuery,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-visits`, JSON.stringify(query ?? {})],
    () => getVisits(query ?? {}),
    mergedOptions,
  );
}
